export const prefetchImage = src => {
  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.as = 'image';
  link.href = src;
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
};